import { put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import {
  saveRoundIdToStore,
  startRoundSuccessAction,
  changeGameStateAction,
  removeAllToastsAction,
} from 'data/reducers';
import { Notifications, RoundStartedResponse, TableStates } from 'types';

export function* roundStarted({ data: result, type: responseType }: RoundStartedResponse) {
  try {
    if (responseType === Notifications.ROUND_STARTED) {
      const { round } = result;
      yield put(saveRoundIdToStore({ roundId: round.roundId }));
      yield put(changeGameStateAction({ tableState: TableStates.RoundStarted }));
      yield put(startRoundSuccessAction());
      yield put(removeAllToastsAction());
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
